'use client';

import { createContact } from '@/app/actions/collections/contact';
import { Button } from '@/ui/shadcn/button';
import { Input } from '@/ui/shadcn/input';
import { Label } from '@/ui/shadcn/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/ui/shadcn/select';
import { Textarea } from '@/ui/shadcn/textarea';
import Link from 'next/link';
import { useState } from 'react';
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn, FaYoutube, FaWhatsapp, FaPhoneAlt, FaEnvelope } from 'react-icons/fa';


const countryCodes = [
    { code: "+33", country: "France", flag: "🇫🇷" },
    { code: "+32", country: "Belgique", flag: "🇧🇪" },
    { code: "+41", country: "Suisse", flag: "🇨🇭" },
    { code: "+212", country: "Maroc", flag: "🇲🇦" },
    { code: "+216", country: "Tunisie", flag: "🇹🇳" },
    { code: "+213", country: "Algérie", flag: "🇩🇿" },
    { code: "+225", country: "Côte d'Ivoire", flag: "🇨🇮" },
    { code: "+221", country: "Sénégal", flag: "🇸🇳" },
];

export function ContactFormBlock(datas) {

    const [name, setName] = useState("")
    const [email, setEmail] = useState("")
    const [message, setMessage] = useState("")
    const [countryCode, setCountryCode] = useState("+221")
    const [phone, setPhone] = useState("")
    
    const getCurrentFlag = () => {
        return countryCodes.find(country => country.code === countryCode)?.flag || "🇸🇳"
    }

    const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        const cleanedValue = value.replace(/[^\d+\s-]/g, '');
        
        const detectedCountryCode = countryCodes.find(country => 
            cleanedValue.startsWith(country.code)
        );

        if (detectedCountryCode) {
            setCountryCode(detectedCountryCode.code);
            setPhone(cleanedValue);
        } else {
            setPhone(cleanedValue);
        }
    }

    const handleCountryCodeChange = (newCode: string) => {
        setCountryCode(newCode);
    }

    const getFullPhone = () => {
        if (phone.startsWith(countryCode)) {
            return phone
        }
        return `${countryCode} ${phone}`
    }

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        try {
            const phone = getFullPhone();

            const datas = {
                name,
                email,
                phone,
                message,
            }

            const contact = await createContact(datas);

        } catch (error) {
            console.error(error);
        }
        
    }

    return (
        <div className="flex flex-col md:flex-row gap-12 p-0 rounded-3xl container mx-auto text-black my-12">
            {/* Left Side */}
            <div className="flex-1 flex flex-col justify-between">
                <div>
                    <h2 className="text-5xl font-bold mb-4">
                        Contactez-nous
                        </h2>
                    <p className="text-black mb-8">
                        N&apos;hésitez pas à nous contacter pour toute question ou assistance.
                    </p>
                    <div className="flex items-center gap-4 mb-4">
                        <div className="relative flex items-center">
                            <div className="w-10 h-10 mr-4 bg-gray-200 rounded-full flex items-center justify-center">
                                <FaPhoneAlt className="text-lg" />
                            </div>
                            <span className="text-lg">+221 77 097 55 23 (disponible de 9h à 17h)</span>
                        </div>
                    </div>
                    <div className="flex items-center gap-4 mb-4">
                        <div className="relative flex items-center">
                            <div className="w-10 h-10 mr-4 bg-gray-200 rounded-full flex items-center justify-center">
                                <FaEnvelope className="text-lg" />
                            </div>
                            <span className="text-lg">contact@dundshop.sn</span>
                        </div>
                    </div>
                    <Link href="https://wa.me/00221770975523?text=Bonjour%2C%20j'ai%20besoin%20d'aide%20concernant" target='_blank'>
                        <Button variant="dark" size="xl" className='mt-4 mb-8'>
                            <img
                                src={
                                    'https://res.cloudinary.com/dr04tcjag/image/upload/v1741485266/whatsapp_egnfsn.svg'
                                }
                                alt="dundshop logo"
                                className="w-6 h-6"
                            />
                            <span>Contactez-nous par message</span>
                        </Button>
                    </Link>
                </div>
                <div>
                    <p className="font-semibold mb-2">Suivez-nous</p>
                    <div className="flex gap-3 text-white">
                        <a href="#" className="bg-[#23262F] hover:bg-primary transition-all p-2 rounded"><FaFacebookF /></a>
                        <a href="#" className="bg-[#23262F] hover:bg-primary transition-all p-2 rounded"><FaTwitter /></a>
                        <a href="#" className="bg-[#23262F] hover:bg-primary transition-all p-2 rounded"><FaInstagram /></a>
                        <a href="#" className="bg-[#23262F] hover:bg-primary transition-all p-2 rounded"><FaLinkedinIn /></a>
                        <a href="#" className="bg-[#23262F] hover:bg-primary transition-all p-2 rounded"><FaYoutube /></a>
                        <a href="#" className="bg-[#23262F] hover:bg-primary transition-all p-2 rounded"><FaWhatsapp /></a>
                    </div>
                </div>
            </div>
            {/* Right Side - Form */}
            <form className="flex-1 bg-gray-200 rounded-2xl p-8 flex flex-col gap-6 shadow-lg" onSubmit={handleSubmit}>
                <div className="flex flex-col md:flex-row gap-6">
                    <div className="flex-1">
                        <Label className='mb-2'>Nom</Label>
                        <Input type="text" className='bg-white' placeholder="Bamba Ndiaye" value={name} onChange={(e) => setName(e.target.value)}/>
                    </div>
                    <div className="flex-1">
                        <Label className='mb-2'>Email</Label>
                        <Input type="email" className='bg-white' placeholder="bamba@ndiaye.com" value={email} onChange={(e) => setEmail(e.target.value)}/>
                    </div>
                </div>
                <div className="flex gap-6">
                    <div className="flex-1">
                    <Label htmlFor="phone" className='mb-2'>Votre numéro de téléphone :</Label>
                    <div className="flex gap-2">
                        <Select value={countryCode} onValueChange={handleCountryCodeChange}>
                            <SelectTrigger className="w-[120px] bg-white">
                                <SelectValue>
                                    <span className="flex items-center gap-2">
                                        <span className="text-lg">{getCurrentFlag()}</span>
                                        <span>{countryCode || "Indicatif"}</span>
                                    </span>
                                </SelectValue>
                            </SelectTrigger>
                            <SelectContent>
                                {countryCodes.map((country) => (
                                    <SelectItem key={country.code} value={country.code}>
                                        <span className="flex items-center gap-2">
                                            <span className="text-lg">{country.flag}</span>
                                            <span>{country.code}</span>
                                        </span>
                                    </SelectItem>
                                ))}
                            </SelectContent>
                        </Select>
                        <Input 
                            id="phone" 
                            name="phone" 
                            type="tel" 
                            placeholder="Exemple : 77 098 39 44" 
                            className="flex-1 bg-white"
                            required
                            value={phone}
                            onChange={handlePhoneChange}
                        />
                    </div>
                    </div>
                </div>
                <div>
                    <Label className='mb-2'>Message</Label>
                    <Textarea className='bg-white' placeholder="Bonjour, je souhaite..." value={message} onChange={(e) => setMessage(e.target.value)}/>
                </div>
                <Button type="submit" size='xl'>Envoyer</Button>
            </form>
        </div>
    );
}
